import React from "react";
import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import { Grid } from "@mui/material";
import FaqCategoryModel from "components/FaqComponent/FaqCategoriesModel/FaqCategoryModel";
import EditFaqCategories from "components/FaqComponent/FaqCategoriesModel/EditFaqCategories";
import FaqCategories from "components/FaqComponent/FaqCategories";
import FaqCategoriesStatus from "components/FaqComponent/FaqCategoriesStatus";
import { FaqApi } from "stores/FaqTableStore/FaqApi";
import Breadcrumbs from "components/common/Breadcrumbs";
import Link from "components/common/Link";
import FaqCategoryDeleteModel from "components/FaqComponent/FaqCategoriesModel/FaqCategoryDeleteModel";

class FaqCategoryContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      openDialoge: false,
      openStatus: false,
      openDeleteModel: false,
      loading: false,
      AddCategoriesConfirmDaialog: false,
      CategoriesStatus: "",
      CategoriesStatusId: "",
      editData: {},
      addInputVisible: false,
      deleteId: null,
    };
  }

  componentDidMount() {
    this.props.getCategoriesList();
    this.props.getFaqParentCategories({ parent_id: 0 ,
      // pagetype:pagetype 
    });
  }
  handleClickOpen = (data) => {
    this.setState({ openDialoge: true, editData: data });
  };
  handleEditClose = () => {
    this.setState({ openDialoge: false });
  };
  handleClickOpenModel = () => {
    this.setState({ open: true });
  };
  handleClose = () => {
    this.setState({ open: false });
  };
  handleDeleteOpenModel = (id) => {
    this.setState({ openDeleteModel: true, deleteId: id });
  };
  handleDeleteCloseModel = () => {
    this.setState({ openDeleteModel: false });
  };
  handleClickOpenStatus = (id, status) => {
    this.setState({
      openStatus: true,
      CategoriesStatus: status,
      CategoriesStatusId: id,
    });
  };

  handleStatusClose = () => {
    this.setState({ openStatus: false });
  };

  submitCategories = async (data) => {
    await FaqApi.postFaqCategoriesApi(data);
    this.handleClickOpen();
  };

  handleSubmit = async (value) => {
    if (value.category_id === null) {
      const payload = {
        name: value.category_id,
      };
      await this.props.PostFaqCategories(payload);
    } else {
      const payload = {
        name: value.category_id,
        parent_id: value.parent_id,
        content_type: value.content_type,
      };
      await this.props.PostFaqCategories(payload);
    }

    // setTimeout(() => {
      this.props.getCategoriesList();
      this.props.getFaqParentCategories({ parent_id: 0 ,
        // pagetype:pagetype
      });
    // }, 100);
  };

  handleClickEditCategoriesSubmit = async () => {
    const { id, name, parent_id } = this.state.editData;
    await FaqApi.UpdateFaqCategoriesApi({
      id,
      name: name,
      parent_id: parent_id,
    });
    this.props.snackbarAction({
      open: true,
      message: 'category edit successfully',
      severity: "success",
  })
    // setTimeout(() => {
      this.props.getCategoriesList();
      this.props.getFaqParentCategories({ parent_id: 0 });
    // }, 1000);
    this.setState({ openDialoge: false });
    
  };
  categoriesChange = (val) => {
    this.props.getCategoriesList({ id: val });
  };
  handleOnChange = (event) => {
    const { value, name } = event.target;
    this.setState((prevState) => ({
      editData: {
        ...prevState.editData,
        [name]: value,
      },
    }));
  };

  handleCategoriChange = (value) => {
    if (value === "all") {
      this.props.getCategoriesList();
    } else {
      const payload = {
        parent_id: value,
      };

      this.props.getCategoriesList(payload);
    }
  };

  handlePageTypeChange = (value) => {
    const payload = {
      parent_id: 0,
      content_type:value
    };

    this.props.getFaqParentCategories(payload);
  };

  handleEnable = async () => {
    const { CategoriesStatus, CategoriesStatusId } = this.state;

    await FaqApi.UpdateFaqCategoriesApi({
      id: CategoriesStatusId,
      status: CategoriesStatus.toString(),
    });
    // setTimeout(() => {
      this.props.getCategoriesList();
      this.props.getFaqParentCategories({ parent_id: 0 });
    // }, 1000);
    this.setState({ openStatus: false });
  };

  handleDelete = async () => {
    const { deleteId } = this.state;
    await this.props.FaqCategoriesDeleteAction(deleteId);
    this.setState({ openDeleteModel: false });
    this.props.snackbarAction({
      open: true,
      message: 'category delete successfully',
      severity: "success",
  })
    // setTimeout(() => {
      this.props.getCategoriesList();
      this.props.getFaqParentCategories({ parent_id: 0 });
    // }, 1000);
  };

  render() {
    const { CategoriesList, ParentCategoriesList } = this.props;

    return (
      <>
     <Stack p={1} mt={2}>
          <Breadcrumbs separator="›" aria-label="breadcrumb">
            <Link color="textSecondary" href="/faqs" underline="none">
              FAQs
            </Link>
            <Link color="primary" underline="none">
              Categories
            </Link>
          </Breadcrumbs>
        </Stack>
        <Grid item xs={12}>
          <Paper sx={{ p: 3 }}>
            <Stack spacing={3}>
              <FaqCategories
                category={CategoriesList}
                parentCategory={ParentCategoriesList}
                onSubmit={this.handleSubmit}
                data={CategoriesList}
                handleClickOpen={this.handleClickOpen}
                handleClickOpenModel={this.handleClickOpenModel}
                handleClickOpenStatus={this.handleClickOpenStatus}
                OnCategoriesChange={this.categoriesChange}
                handleCategoriChange={this.handleCategoriChange}
                handleDeleteOpenModel={this.handleDeleteOpenModel}
                getCategoriesList={this.props.getCategoriesList}
                getFaqParentCategories={this.props.getFaqParentCategories}
                handlePageTypeChange={this.handlePageTypeChange}
              />

              <FaqCategoryModel
                open={this.state.open}
                handleClose={this.handleClose}
              />
              <EditFaqCategories
                data={this.props.ParentCategoriesList}
                open={this.state.openDialoge}
                handleEditClose={this.handleEditClose}
                editData={this.state.editData}
                handleOnChange={(editData) => {
                  this.handleOnChange(editData);
                }}
                handleClickEditCategoriesSubmit={
                  this.handleClickEditCategoriesSubmit
                }
                OnCategoriesChange={this.categoriesChange}
              />

              <FaqCategoriesStatus
                open={this.state.openStatus}
                handleStatusClose={this.handleStatusClose}
                handleEnable={this.handleEnable}
                CategoriesStatus={this.state.CategoriesStatus}
              />

              <FaqCategoryDeleteModel
                open={this.state.openDeleteModel}
                handleDelete={this.handleDelete}
                handleDeleteCloseModel={this.handleDeleteCloseModel}
              />
            </Stack>
          </Paper>
        </Grid>
      </>
    );
  }
}

export default FaqCategoryContainer;
